/**
 *
 */
export default class ForumMessage {
  text: string;
  expire: number;

  constructor(text: string, date: number) {
    this.text = text;
    this.expire = date;
  }
}
